import {ModelInterface} from './entity';
import {UserPlace} from './place';
import {Currency} from './request';
import {DocumentType} from './user-document';
export * from './user-document';

export enum UserPlatformRole {
  CUSTOMER = 0,
  WORKER = 1,
  ORBIS_CONSUMER = 2,
  ADMIN = 3,
  PARTNER_REGISTRER = 4,
  KIOSK = 5,
  EXTERNAL_MONITOR = 6
}

export const UserRoles = [
  {name: 'customer', value: 0},
  {name: 'worker', value: 1},
  {name: 'orbis_consumer', value: 2},
  {name: 'admin', value: 3},
  {name: 'partner_registrer', value: 4},
  {name: 'kiosk', value: 5}
];
export enum UserPermission {
  ALLOW_CREATE = 'allowCreate',
  ALLOW_CONSUME = 'allowConsume',
  ALLOW_CONTROL = 'allowControl',
  ALLOW_ADMIN = 'allowAdmin',
  ALLOW_EXTENSION = 'allowExtension'
}
export const enum UserType {
  ONE_SHOT = 0,
  RECURRENT = 1
}

export interface User extends ModelInterface<number> {
  userId: string;
  role: UserPlatformRole;
  lastLogin: string;
  lastUseApproximation: string;
  loginCount: number;
  accountName: string;
  passwordHash: string;
  password?: string;
  salt: string;
  iatNotBefore: string;
  lockedAt: string;
  name: string;
  confirmedAt: string;
  lastConnectIp: string;
  type: UserType;
  typeRecurrent: string;
  fingerBytes?: string;
  links: UserPlace[];
  server: ServerInfo;
  finger?: boolean;
  rates: {date?: string, base?: string, rates?: {[id: string]: number}};
  priceOverrides: PriceOverride[];
  places: {id: string, longName: string}[];
}

export interface PriceOverride {
  id: string;
  nationality: string;
  validFrom: string;
  validUntil: string;
  currency: string;
  valueCents: number;
}

export interface UserRole {
  isOrbis: boolean;
  isWorker: boolean;
  isCustomer: boolean;
  isAdmin: boolean;
  isPartnerRegister: boolean;
  isKiosk: boolean;
  isExternalMonitor: boolean;
}

export const enum VerifyChecks {
    NO_DUPLICATE_LIVE = 'NO_DUPLICATE_LIVE',
    ZIM_CIVIL_REGISTRY = 'ZIM_CIVIL_REGISTRY',
}
export type VerifyCheck = {name: VerifyChecks, host?: string, port?: number, keys?: string[]};
export interface Document {
  type: string;
  id: DocumentType;
  amountCents: number;
  amountCentsDyn: string;
  currency: Currency;
  active: boolean;
  schema: string;
  autoConfirm: string;
  manualConfirmRounds: number;
  autoTransfer: 'orbis' | undefined;
  customer: boolean;
  kiosk: boolean;
  indexedFields: string[];
  parentType: string;
  metadataPrecedence: boolean;
  multiUsage: boolean;
  usageCount: number;
  isUsage: string;
  usageUntilFromNowMillis: string;
  defaultLocalUsageUntilFromNowMillis: string;
  localUsageUntilFromNowMillis: string;
  usageIndexFields: string[];
  paidOnline: boolean | string;
  onConsume?: 'visaextension1' | 'visaextension2';
  valueRange: number;
  onlyIn?: string[];
  parentLink?: number;
  timeSlotPlaceIdIndex?: number;
  frontendParameters?: {
    sitesNonMandatoryExitPicture?: string[]
  };
  currencyDyn?: string
  validForGates?: boolean;
  blockConsumeIfDelayed?: boolean;
  verifyChecks?: VerifyCheck[];
}

export interface ServerInfo {
  testMode: boolean;
  usingFaceMatch: boolean;
  usingFaceDetection: boolean;
  selfRegister: boolean;
  languages: string[];
  domain: string;
  dailyOtpRequired: boolean;
  emailConfig: {
    copyrightName: string,
    address: string,
    email: string,
    phone: string,
    imageLogo: string
  };
  bank?: string;
  jwtCertificate: string;
  jwtCertificateExternalWorkers: string | undefined;
  rolePrefixExternalWorkers: string | undefined;
  ldap?: {url: string, baseDn: string, userSearchFilter: string, rolesAttribute: string, officeAttribute: string, defaultOffice: string, tlsOptions?: {rejectUnauthorized: boolean}};
  regDays: number;
  maxOverstayGraceMillis: number;
  serverPhones: string[];
  country: string;
  paymentDeclarationValidity: number;
  paymentTimeSlotDuration: number;
  paymentTimeSlotMinDistanceHours: number;
  allowedBookTimeslotPortIds?: string[];
  paymentRequests: Document[];
  mainCurrency: Currency;
  paymentNonDocumentsCents: {
      overstay: number
  };
  maxDailyPayments: number;
  maxMonthlyPaymentsCustomer: number;
  maxMonthlyPaymentsKiosk: number;
  mnta: {
    host: string,
    ips: string[],
    applicationId: string
  };
  name: string; // 'evisa-zim', 'pass-com' etc.
  product: string; // evisa or pass
}

export interface UserTable {
  id: string;
  userId: string;
  name: string;
  role: UserPlatformRole;
  email: string;
  creationDate: string;
}

export enum Gender {
  MALE = 'male',
  FEMALE = 'female',
  OTHER = 'other'
}

export enum MaritalStatus {
  MARRIED = 'married',
  SINGLE = 'single',
  SEPARATED = 'separated',
  DIVORCED = 'divorced',
  WIDOWED = 'widowed'
}
